import React, { useEffect, useState } from "react";
import { addLessonCate, deleteLessonCate, editLessonCate, getLessonCates, getLanguages, getModules } from "../../services/apiService";
import {
  Container,
  Row,
  Col,
  Button,
  Table,
  Form,
  Modal,
} from "react-bootstrap";
import Sidebar from "../Sidebar/Sidebar";

export default function LessonCates() {
  const [modalVisible, setModalVisible] = useState(false)
  const [editModalVisible, setEditModalVisible] = useState(false)
  const [lessonCates, setLessonCates] = useState([])
  const [form, setForm] = useState({
    name: '',
  })
  const [editForm, setEditForm] = useState({
    name: '',
  })
  const [editId, setEditID] = useState(null)
  const [languages, setLanguages] = useState([])
  const [modules, setModules] = useState([])

  useEffect(() => {
    fetchLessonCates()
    fetchLanguages()
    fetchModules()
  }, [])

  const fetchLessonCates = async () => {
    const lessonCates = await getLessonCates();
    setLessonCates(lessonCates)
  }

  const fetchLanguages = async () => {
    const languages = await getLanguages();
    setLanguages(languages)
  }

  const fetchModules = async () => {
    const modules = await getModules();
    setModules(modules)
  }

  const handleAddLessonCate = async () => {
    const response = await addLessonCate(form)
    if(response) fetchLessonCates()
    setModalVisible(false)
  }

  const handleEditLessonCate = async () => {
    const response = await editLessonCate(editForm, editId)
    if(response) fetchLessonCates()
    setEditModalVisible(false)
  }

  const handleDelete = async (id) => {
    const response = await deleteLessonCate(id)
    if(response) fetchLessonCates()
  }

  const handleEdit = (item) => {
    setEditForm({
      name: item.name,
    })
    setEditID(item.id)
    setEditModalVisible(true)
  }

  return (
    <div style={{ flex: 1, height: "100vh", width: "100%" }}>
      <Row style={{ flex: 1, height: "100vh" }}>
        <Col sm={2} style={{ height: "100vh" }}>
          <Sidebar />
        </Col>
        <Col>
          <Container>
            <Container className="mt-3">
              <Row>
                <Col>
                  <div>
                    <Button
                      variant="primary"
                      onClick={() => setModalVisible(true)}
                    >
                      Ders Kategorisi Ekle
                    </Button>
                    <Table className="mt-3" striped bordered hover>
                      <thead>
                        <tr>
                          <th>ID</th>
                          <th>İsim</th>
                          <th>İşlemler</th>
                        </tr>
                      </thead>
                      <tbody>
                        {lessonCates.map((item) => (
                          <tr key={item.id}>
                            <td>{item.id}</td>
                            <td>{item.name}</td>
                            <td>
                              <Button variant="info" size="sm" onClick={() => handleEdit(item)}>
                                Düzenle
                              </Button>{" "}
                              <Button variant="danger" size="sm" onClick={() => handleDelete(item.id)}>
                                Sil
                              </Button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                </Col>
              </Row>
            </Container>

            <Modal show={modalVisible} onHide={() => setModalVisible(false)}>
              <Modal.Header closeButton>
                <Modal.Title>Kategori Ekle</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Form>
                  <Form.Group controlId="formLessonCateName">
                    <Form.Label>Kategori Adı</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Kategori Adı"
                      onChange={(e) => setForm({
                        ...form,
                        name: e.target.value
                      })}
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Kategori Dili</Form.Label>
                    <Form.Select
                      name="language"
                      value={form.language}
                      onChange={(e) => {
                        setForm((prevForm) => ({
                          ...prevForm,
                          language: e.target.value
                        }));
                      }}
                      required
                    >
                      <option key={0} value="" selected disabled>Seçiniz</option>
                      {
                        languages.map(lang => (
                          <option key={lang.id} value={lang.value}>{lang.label}</option>
                        ))
                      }
                    </Form.Select>
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Kategori Modülü</Form.Label>
                    <Form.Select
                      name="module"
                      value={form.module}
                      onChange={(e) => {
                        setForm((prevForm) => ({
                          ...prevForm,
                          module: e.target.value
                        }));
                      }}
                      required
                    >
                      <option key={0} value="" selected disabled>Seçiniz</option>
                      {
                        modules.map(lang => (
                          <option key={lang.id} value={lang.id}>{lang.label}</option>
                        ))
                      }
                    </Form.Select>
                  </Form.Group>
                </Form>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={() => setModalVisible(false)}
                >
                  Kapat
                </Button>
                <Button variant="primary" onClick={handleAddLessonCate}>
                  Ekle
                </Button>
              </Modal.Footer>
            </Modal>

            <Modal show={editModalVisible} onHide={() => setEditModalVisible(false)}>
              <Modal.Header closeButton>
                <Modal.Title>Kategori Ekle</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Form>
                  <Form.Group controlId="formLessonCateName">
                    <Form.Label>Kategori Adı</Form.Label>
                    <Form.Control
                      value={editForm.name}
                      type="text"
                      placeholder="Kategori Adı"
                      onChange={(e) => setEditForm({
                        ...editForm,
                        name: e.target.value
                      })}
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Kitap Dili</Form.Label>
                    <Form.Select
                      name="language"
                      value={form.language}
                      onChange={(e) => {
                        setForm((prevForm) => ({
                          ...prevForm,
                          language: e.target.value
                        }));
                      }}
                      required
                    >
                      <option key={0} value="" selected disabled>Seçiniz</option>
                      {
                        languages.map(lang => (
                          <option key={lang.id} value={lang.value}>{lang.label}</option>
                        ))
                      }
                    </Form.Select>
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Kategori Modülü</Form.Label>
                    <Form.Select
                      name="module"
                      value={form.module}
                      onChange={(e) => {
                        setForm((prevForm) => ({
                          ...prevForm,
                          module: e.target.value
                        }));
                      }}
                      required
                    >
                      <option key={0} value="" selected disabled>Seçiniz</option>
                      {
                        modules.map(lang => (
                          <option key={lang.id} value={lang.id}>{lang.label}</option>
                        ))
                      }
                    </Form.Select>
                  </Form.Group>
                </Form>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={() => setEditModalVisible(false)}
                >
                  Kapat
                </Button>
                <Button variant="primary" onClick={handleEditLessonCate}>
                  Düzenle
                </Button>
              </Modal.Footer>
            </Modal>
          </Container>
        </Col>
      </Row>
    </div>
  );
}
